import { css } from "@emotion/css";

export const agentLauncherButtonCSS = css`
  border-radius: 6px;
  border: 1px solid #e50000;
  background: #fff;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: "Roboto Condensed", Roboto, sans-serif;
  white-space: nowrap;
  cursor: pointer;
  height: 26px;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 0 9px 1px rgba(229, 0, 0, 0.3);
    background: linear-gradient(
      to right,
      rgba(255, 69, 69, 0.15),
      rgba(229, 0, 0, 0.15),
      rgba(189, 0, 65, 0.15)
    );
  }

  &:active,
  &:focus,
  &.active {
    outline: none;
  }

  &.active {
    background: linear-gradient(
      to right,
      rgba(255, 69, 69, 0.3),
      rgba(229, 0, 0, 0.3),
      rgba(189, 0, 65, 0.3)
    );
  }

  & > svg {
    vertical-align: middle !important;
    height: 18px !important;
    margin-right: 4px;
  }
`;
